<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { useNotifyStore } from '@/stores/notify'
import { onMounted } from 'vue'

const chatStore = useChatStore()

onMounted(() => {
  chatStore.connectWebSocket()
})
</script>

<template>
  <RouterView />
</template>

<style scoped></style>
